import { useEffect, useState } from "react"

function useMediaQuery(query: string): boolean {
	const [matches, setMatches] = useState(
		() => typeof window !== "undefined" && window.matchMedia(query).matches,
	)
	useEffect(() => {
		const list = window.matchMedia(query)
		const update = () => setMatches(list.matches)
		update()
		list.addEventListener("change", update)
		return () => list.removeEventListener("change", update)
	}, [query])
	return matches
}

/** С lg панели блока и тест-чата помещаются рядом с холстом; уже: шторка и полный экран. */
export const useIsDesktopEditor = () => useMediaQuery("(min-width: 1024px)")
